export const blogPosts = [
  {
    slug: 'turn-receipts-into-a-budget-you-can-use',
    title: 'Turn receipts into a budget you can actually use',
    excerpt:
      'A simple weekly routine for turning everyday purchases into clearer categories, better budgets, and fewer surprises.',
    publishedAt: '2026-07-24',
    readTime: '5 min read',
    category: 'Budgeting',
    content: [
      {
        heading: 'Start with what really happened',
        paragraphs: [
          'A useful budget begins with real spending, not a perfect version of what you hoped to spend. Receipts give you the detail needed to see the difference.',
          'Capture purchases while they are still fresh, then review the merchant, total, and category. A few minutes of cleanup now makes the rest of your monthly review much easier.',
        ],
      },
      {
        heading: 'Review patterns once a week',
        paragraphs: [
          'Pick one consistent day to scan recent purchases. Look for categories that are growing faster than expected and expenses that repeat.',
          'The goal is not to judge every purchase. It is to notice patterns early enough that you can make a useful adjustment before the month is over.',
        ],
      },
      {
        heading: 'Let the budget change with you',
        paragraphs: [
          'If your actual priorities have shifted, update the plan. A budget should be a current decision-making tool, not a record of an outdated guess.',
        ],
      },
    ],
  },
  {
    slug: 'five-receipt-details-worth-tracking',
    title: '5 receipt details worth tracking',
    excerpt:
      'The small pieces of purchase data that make expense searches, category reviews, and future shopping noticeably easier.',
    publishedAt: '2026-07-15',
    readTime: '4 min read',
    category: 'Receipt scanning',
    content: [
      {
        heading: 'Keep the essentials',
        paragraphs: [
          'Merchant, purchase date, total, category, and line items provide a strong foundation for a personal spending record. Together, they answer where, when, how much, why, and what you bought.',
          'Line items are especially useful when one receipt crosses several categories or when you want to compare the price of something you buy regularly.',
        ],
      },
      {
        heading: 'Add context while it is easy',
        paragraphs: [
          'A short note can explain whether a purchase was reimbursable, shared, unusual, or connected to a specific event. That context is difficult to reconstruct months later.',
        ],
      },
      {
        heading: 'Review before you save',
        paragraphs: [
          'Receipt scanning reduces typing, but a quick review still matters. Confirm the total and date first, then correct only the details that will affect how you use the data.',
        ],
      },
    ],
  },
  {
    slug: 'a-calm-end-of-month-money-review',
    title: 'A calmer end-of-month money review',
    excerpt:
      'Use a short, repeatable checklist to close out the month without turning your finances into an all-day project.',
    publishedAt: '2026-07-02',
    readTime: '6 min read',
    category: 'Money habits',
    content: [
      {
        heading: 'Make the review small enough to repeat',
        paragraphs: [
          'A good monthly review does not need to be exhaustive. Give yourself a focused window to check totals, correct obvious gaps, and decide what should change next month.',
        ],
      },
      {
        heading: 'Ask three useful questions',
        paragraphs: [
          'Which category surprised you? Which recurring expense still earns its place? What upcoming purchase needs room in next month’s plan?',
          'These questions keep the review connected to decisions instead of turning it into a long accounting exercise.',
        ],
      },
      {
        heading: 'Finish with one adjustment',
        paragraphs: [
          'Choose one change you can carry into the next month: a category limit, a canceled subscription, or a planned savings transfer. One clear action is more useful than a page of vague intentions.',
        ],
      },
    ],
  },
];

export const formatBlogDate = (date) =>
  new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(`${date}T12:00:00`));
